import { render, staticRenderFns } from "./BaseLuo.vue?vue&type=template&id=8966b132&"
import script from "./BaseLuo.vue?vue&type=script&lang=js&"
export * from "./BaseLuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports